import React from 'react';
import styled from 'styled-components';

import { imageUrl } from '~/utils/url-helpers';

import PageTitle from '~/components/common/page-title';

import { OntarioRow, OntarioColumn, Heading1, Heading2 } from '~/theme/';
import { spacing, media } from '~/theme';
import { LeadText } from '~/components/common/modal/styles';
import { AdminMessage } from '~/models/admin';

// Maintenance page styled components
const Wrapper = styled.div`
    height: 100vh;
    background-image: url(${imageUrl('images/ontario-trillium-bg.svg')});
    background-repeat: no-repeat;
    background-position: top -${spacing.spacing5} right -3.5rem;
    background-size: 250px;

    @media ${media.small} {
        background-size: 450px;
        background-position: top -${spacing.spacing4} right ${spacing.spacing4};
    }

    @media ${media.medium} {
        background-size: 600px;
        background-position: top right ${spacing.spacing9};
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: calc(${spacing.spacing9} + ${spacing.spacing2});

    @media ${media.small} {
        margin-top: calc(${spacing.spacing9} + ${spacing.spacing9} + ${spacing.spacing2});
    }
`;

const LogoImage = styled.img`
    max-width: 175px;
    width: 100%;
`;

const MarginBlock = styled.div`
    margin-top: ${spacing.spacing1};

    @media ${media.small} {
        margin-top: ${spacing.spacing6};
    }
`;

interface MaintenanceProps {
    message?: AdminMessage;
}

const Maintenance = ({ message }: MaintenanceProps) => {
    return (
        <Wrapper>
            <PageTitle title="Sign up for ServiceOntario App - Maintenance | Ontario.ca" />
            <OntarioRow>
                <OntarioColumn>
                    <TextContainer>
                        <LogoImage src={imageUrl('images/ontario-logo--maintenance.png')} alt="" />
                        <div lang="en">
                            <Heading1>We&apos;ll be back soon!</Heading1>
                            <LeadText>
                                {message?.messageContent
                                    ? message.messageContent
                                    : 'This service is currently down for maintenance.'}
                            </LeadText>
                            <LeadText>
                                We apologize for any inconvenience. Thank you for your
                                understanding.
                            </LeadText>
                            <LeadText>Please visit us again.</LeadText>
                        </div>

                        <MarginBlock lang="fr">
                            <Heading2 $styledAs="h1">Nous serons de retour bientôt!</Heading2>
                            <LeadText>
                                {message?.messageContentFrench
                                    ? message.messageContentFrench
                                    : 'Ce service est actuellement indisponible pour maintenance.'}
                            </LeadText>
                            <LeadText>
                                Nous nous excusons pour tout inconvénient. Merci de votre
                                compréhension.
                            </LeadText>
                            <LeadText>S&apos;il vous plaît visitez-nous à nouveau.</LeadText>
                        </MarginBlock>
                    </TextContainer>
                </OntarioColumn>
            </OntarioRow>
        </Wrapper>
    );
};

export default Maintenance;
